export const labelCell = {width: 180, py: 0.5, verticalAlign: 'middle', fontWeight: 600};
export const labelCellSx = {width: 180, py: 0.5, verticalAlign: 'middle'};
export const descCellSx = {py: 0.5, verticalAlign: 'middle'};
export const amountCellSx = {width: 180, py: 0.5, verticalAlign: 'middle'};
